import React, { Component } from 'react';
import './mainpage.css';
import logo from './logo.png';
import { Button } from '@fluentui/react-components';
import { 
  Navigation24Regular,
  MailFilled,
  SearchFilled,
  SearchInfoFilled,
  OrganizationFilled,
  PeopleFilled,
  ScalesFilled
} from '@fluentui/react-icons';
import NavBar from './NavBar';

interface PrivacyProps {}

interface PrivacyState {
  isMenuOpen: boolean;
  isProductsMenuOpen: boolean;
  isSolutionsMenuOpen: boolean;
}

class Privacy extends Component<PrivacyProps, PrivacyState> {
  constructor(props: PrivacyProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isProductsMenuOpen: false,
      isSolutionsMenuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  toggleProductsMenu = () => {
    this.setState({ isProductsMenuOpen: !this.state.isProductsMenuOpen });
  };

  closeProductsMenu = () => {
    this.setState({ isProductsMenuOpen: false });
  };

  toggleSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: !this.state.isSolutionsMenuOpen });
  };

  closeSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: false });
  };

  render() {
    const { isMenuOpen } = this.state;

    return (
      <div className="main-page">
        {/* Top Navigation */}
        <NavBar />

        {/* Privacy Policy Content */}
        {/* Privacy Policy Content */}
        <section style={{ padding: '4rem 0', background: '#fff', minHeight: '70vh' }}>
          <div className="container">
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
              <h1 style={{ fontSize: '1.75rem', marginBottom: '1.5rem', color: '#111827', fontWeight: '700', textAlign: 'left' }}>PRIVACY POLICY</h1>
              
              <div style={{ lineHeight: '1.6', color: '#374151', fontSize: '0.875rem', textAlign: 'left' }}>
                <p style={{ marginBottom: '1rem' }}>
                  Our company "Psarakis Antonios MON IKE" trading as "META 365" with registered office in Greece (Voulgaro Kisamou Chania) ("META 365") operates the Website Name website, which provides Services.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Services, the Website Name website.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Website URL, unless otherwise defined in this Privacy Policy.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Information Collection and Use</h2>
                <p style={{ marginBottom: '1rem' }}>
                  For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, email, phone number, and postal address. The information that we collect will be used to contact or identify you.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Log Data</h2>
                <p style={{ marginBottom: '1rem' }}>
                  We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Cookies</h2>
                <p style={{ marginBottom: '1rem' }}>
                  Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Service Providers</h2>
                <p style={{ marginBottom: '1rem' }}>
                  We may employ third-party companies and individuals due to the following reasons:
                </p>
                <ul style={{ marginBottom: '1rem', marginLeft: '2rem' }}>
                  <li>To facilitate our Service;</li>
                  <li>To provide the Service on our behalf;</li>
                  <li>To perform Service-related services; or</li>
                  <li>To assist us in analyzing how our Service is used.</li>
                </ul>

                <p style={{ marginBottom: '1rem' }}>
                  We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Security</h2>
                <p style={{ marginBottom: '1rem' }}>
                  We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Confidentiality</h2>
                <p style={{ marginBottom: '1rem' }}>
                  We do not provide or otherwise transmit or publish personal data of visitors or users of the website to third parties, without their consent, with the exception of aforementioned recipients to facilitate functioning of the portal, with the exception of application of relevant legal requirements and only to the competent authorities.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  Personal data held may be disclosed to the competent judicial, policy and other administrative authorities, subject to lawful request and in accordance with applicable legal provisions. Furthermore, in the case of a legal order by a public prosecutor or other authority or when criminal investigations or preliminary examinations are conducted, we are obliged to provide access to the relevant data and to make them available to the requesting authority.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  We do not forward the personal data of users to third countries or international organisations.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Links to Other Sites</h2>
                <p style={{ marginBottom: '1rem' }}>
                  Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Children's Privacy</h2>
                <p style={{ marginBottom: '1rem' }}>
                  Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Changes to This Privacy Policy</h2>
                <p style={{ marginBottom: '1rem' }}>
                  We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Privacy Rights</h2>
                <p style={{ marginBottom: '1rem' }}>
                  In some regions (like the EEA, UK, and Canada), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us by email at: <a href="mailto:apsarakis@meta-365.com">apsarakis@meta-365.com</a> or by letter to the following address: Voulgaro Kisamou- Chania -Greece.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  If you are located in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: <a href="https://edpb.europa.eu/about-edpb/about-edpb/members_en" target="_blank" rel="noopener noreferrer">https://edpb.europa.eu/about-edpb/about-edpb/members_en</a>.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  If you are located in Switzerland, the contact details for the data protection authorities are available here: <a href="https://www.edoeb.admin.ch/edoeb/en/home.html" target="_blank" rel="noopener noreferrer">https://www.edoeb.admin.ch/edoeb/en/home.html</a>.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by email at: <a href="mailto:apsarakis@meta-365.com">apsarakis@meta-365.com</a> or by letter to the following address: Voulgaro Kisamou- Chania -Greece below or updating your preferences.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  However, please note that this will not affect the lawfulness of the processing before its withdrawal, nor when applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  You can unsubscribe from our marketing and promotional communications at any time by clicking on the unsubscribe link in the emails that we send, replying "STOP" or "UNSUBSCRIBE" to the SMS messages that we send or by contacting us by email at: <a href="mailto:apsarakis@meta-365.com">apsarakis@meta-365.com</a> or by letter to the following address: Voulgaro Kisamou- Chania -Greece. You will then be removed from the marketing lists however, we may still communicate with you, for example to send you service-related messages that are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes.
                </p>

                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>Contact Us</h2>
                <p style={{ marginBottom: '1rem' }}>
                  If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us by email at: <a href="mailto:apsarakis@meta-365.com">apsarakis@meta-365.com</a> or by letter to the following address: Voulgaro Kisamou- Chania -Greece.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>Products</h4>
                <ul>
                  <li><a href="/solutions/pentities">pEntities</a>
                    <ul className="footer-subnav">
                      <li><a href="/solutions/automation">Automation Module</a></li>
                      <li><a href="/solutions/ticketing">Ticketing Module</a></li>
                      <li><a href="/solutions/hr-template">HR Module</a></li>
                      <li><a href="/solutions/case-management">Legal Module</a></li>
                      <li><a href="/solutions/hr-hub">Employee Module</a></li>
                    </ul>
                  </li>
                  <li><a href="/solutions/pshareemail">PShareEmail</a></li>
                  <li><a href="/solutions/docsearch">DocSearch Tool</a></li>
                  <li><a href="/solutions/searchassistant">Search Assistant</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/get-started">Get Started</a></li>
                  <li><a href="/contactus">Contact Us</a></li>
                  <li><a href="/plans-pricing">Plans & Pricing</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <ul>
                  <li><a href="/knowledge">Knowledge Base</a></li>
                  <li><a href="/technical-support">Technical Support</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Contact Us</h4>
                <div className="footer-office">
                  <p className="office-name">Athens Office</p>
                  <p>365 Kifisias Avenue, Kifisia, 14561</p>
                  <p>Ground Floor, Inside the Arcade</p>
                  <p>Tel: (+30)-210-260-3764</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Thessaloniki Office</p>
                  <p>15 Nikiforou Ouranou & Minotavrou Streets</p>
                  <p>Thessaloniki, 54627, PORTO CENTER, Building G1, 3rd Floor</p>
                  <p>Tel: (+30)-231-005-3361</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Crete Office</p>
                  <p>Kisamos, Chania</p>
                  <p>Tel: (+30)-2822-051309</p>
                </div>
                <p className="footer-email">info@meta-365.com</p>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2026 Meta-365. All rights reserved.</p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/meta-365" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M4.98%203.5C4.98%204.88%203.87%206%202.5%206S0%204.88%200%203.5%201.12%201%202.5%201s2.48%201.12%202.48%202.5zM.25%208h4.5v13H.25V8zM8.5%208h4.31v1.78h.06c.6-1.14%202.07-2.34%204.26-2.34C21.5%207.44%2022.5%2010%2022.5%2014.02V21H18v-6.1c0-1.46-.03-3.33-2.03-3.33-2.03%200-2.34%201.58-2.34%203.22V21H8.5V8z'/%3E%3C/svg%3E" alt="LinkedIn" width="18" height="18" /></a>
                <a href="https://www.facebook.com/profile.php?id=61589941284929" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M24%2012.07C24%205.4%2018.63%200%2012%200S0%205.4%200%2012.07C0%2018.1%204.39%2023.1%2010.13%2024v-8.44H7.08v-3.49h3.05V9.41c0-3.02%201.79-4.69%204.53-4.69%201.31%200%202.68.24%202.68.24v2.97h-1.51c-1.49%200-1.96.93-1.96%201.89v2.25h3.33l-.53%203.49h-2.8V24C19.61%2023.1%2024%2018.1%2024%2012.07z'/%3E%3C/svg%3E" alt="Facebook" width="18" height="18" /></a>
              </div>
              <div className="footer-links">
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms-of-use">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Privacy;

